export const SEARCH_TERMS = ["title", "meta_title"];
export const inputFields = {
  title: {
    type: "string",
    required: true,
    title: "Title",
    slug: true,
    inputType: "text",
  },
  content: {
    type: "html",
    required: false,
    title: "Content",
  },
  gallery: {
    type: "gallery",
    required: false,
    title: "Gallery",
  },
  goal: {
    type: "string",
    required: true,
    title: "Goal",
    inputType: "number",
  },
  achieved: {
    type: "string",
    required: true,
    title: "Achieved",
    inputType: "number",
  },
  slug: {
    type: "slug",
    required: false,
    targetField: "title",
    title: "Slug",
  },
};
export const initialValues = {
  title: "",
  content: "",
  goal: "",
  achieved: "",
  slug: "",
};

export const view_all_table = [
  { name: "Title", value: "title" },
  { name: "Goal", value: "goal" },
  { name: "Achieved", value: "achieved" },
  { name: "Slug", value: "slug" },
];
